import { call, put } from "redux-saga/effects";
import {
    requestDisablePluginClient,
    requestEnablePluginClient,
    requestGetPluginAdminCatalog,
    requestGetPluginAvailableClients,
    requestGetPluginClients,
} from "../requests/pluginAdmin";
import { showAlert } from "../../slices/alerts";
import { safeErrorMessage } from "../../../utils/errorUtils";

function* respond(callback, request, ...args) {
    try {
        const response = yield call(request, ...args);
        if (callback) callback(response.data);
    } catch (error) {
        yield put(showAlert({ severity: "error", message: safeErrorMessage(error) }));
        if (callback) callback(null);
    }
}

export function* handleGetPluginAdminCatalog(action) {
    const { callback } = action.payload || {};
    yield* respond(callback, requestGetPluginAdminCatalog);
}

export function* handleGetPluginClients(action) {
    const { pluginId, callback } = action.payload;
    yield* respond(callback, requestGetPluginClients, pluginId);
}

export function* handleGetPluginAvailableClients(action) {
    const { pluginId, callback } = action.payload;
    yield* respond(callback, requestGetPluginAvailableClients, pluginId);
}

export function* handleEnablePluginClient(action) {
    const { pluginId, clientId, callback } = action.payload;
    yield* respond(callback, requestEnablePluginClient, pluginId, clientId);
}

export function* handleDisablePluginClient(action) {
    const { pluginId, clientId, callback } = action.payload;
    yield* respond(callback, requestDisablePluginClient, pluginId, clientId);
}
